import { atom } from 'jotai';

export const groupMenuMessagesShowAtom = atom();
export const showMessagePopUpAtom = atom(false);
export const showActiveCHatAtom = atom(undefined);
export const showNewDirectMessageMenuAtom = atom(false);
export const showNewGroupMessageMenuAtom = atom(false);
export const disableActiveChatSelectionAtom = atom(false);
export const chatsAtom = atom([]);
export const chatsLoadingAtom = atom(true);
export const chatsIsUpdatedAtom = atom(false);
export const showNewMessageStartupAtom = atom(false);

// refetch react query
export const refectSectionAtom = atom(false);
export const TopBarPopUpsAtom = atom({
    message: false,
    notification: false
});

// disable view profile on analytics
export const IsCOurseAnalyticsPageAtom = atom(false);

export const FeaturedPostAddedAtom = atom(false);
export const activeSubReloadAtom = atom(false);

export const groupDataLoadingAtom = atom(false);

export const activeDigestEmailItemAtom = atom('');
export const activeUpcomingEventEmailItemAtom = atom('');

export const newContentEmailItemAtom = atom('');
export const courseSectionContentIsCreatedAtom = atom(false);
export const firstSectionCreationAtom = atom(true);
export const activeMemberIDAtom = atom(undefined);

// profile pop up
export const memberDetailsProfilePopupAtom = atom(false);

// file upload progress
export const postFileIsUploadingAtom = atom(false);

// add members to segment pop up
export const AddableSegmentMembers = atom({
    isOpen: false,
    segmentId: undefined,
    segmentName: undefined
})

// add member to channel pop up
export const AddableChannelMemberAtom = atom({
    open: false,
    channelId: undefined
});

// add member to teammates pop up
export const AddableTeamMateAtom = atom(false);


// Pricing Header styling 
export const resourceSearchStylingAtom = atom('');

// Purchasers Search styling
export const purchasersStylingAtom = atom('');

// scrollToComment
export const scrollToCommentAtom = atom(undefined);

// add unaothorized users lib/course
export const unAuthorizedUsersAtom = atom({
    open: false,
    contentId: undefined,
    contentName: undefined
});

// universal search data 
export const universalSearchResultsAtom = atom();

// community billing plans pop up
export const communityBillingPlansPopupAtom = atom({
    open: false,
    title: undefined,
});

// create lib resource and category pop up
export const createResourcePopupAtom = atom({
    isOpen: false,
    resourceType: undefined,
})

// create subscription pop up
export const createSubscriptionPopupAtom = atom(false)

// library active tab i.e 'All Content' or 'My Library'
export const libraryActiveTabAtom = atom('all_contents')
// library filter tabs i.e 'all, Categories, Videos, Audio, PDFs, Embed, Article'
export const libraryFilterTabsAtom = atom('')
export const courseFilterTabsAtom = atom('')

// rename template pop up
export const renameTemplatePopupAtom = atom(false)

// choice of workflow i.e either filter or action
export const choiceTopPopupAtom = atom(false)

// choice of workflow i.e either filter or action
export const choiceBottomPopupAtom = atom(false)

// open and close getting started sidebar pop up
export const gettingStartedRightSideBarAtom = atom(false)

// open and close edit profile details of a member pop up
export const editProfileDetailsPopupAtom = atom({
    isOpen: false,
    editType: 'profile'
})

// show smartBanner
export const showBannerAtom = atom(false)

// singleContentDisplay for opening library content
export const singleContentDisplayAtom = atom({
    singleContentDisplay: false,
    libraryItemId: undefined,
    libraryItemType: undefined
})

// show upgrade banner
export const showUpgradeBannerAtom = atom({
    isOpen: false,
    isAfter7Days: false,
    upgradeBeforeDate: ''
})

// mini getting started pop up
export const miniGettingStartedPopupAtom = atom(false)

// turnstile verification
export const isHumanVerifiedAtom = atom({
    isVerified: false,
    session_token: undefined || ''
})
// open and close the NonEventMembersPopUp
export const NonEventMembersPopUpAtom = atom(false)
